export default __webpack_public_path__ + "static/media/card-fuzzy-start-color.8f21403f.jpg";